<div class="market-history">
  <h2 class="heading">{{"recent-trades" | translate}}
    <span matTooltipPosition="left" [matTooltip]='companyName' matTooltipClass="custom-tooltip" *ngIf="reuters != null">- <span style="background:#2d3034;padding: 5px; border-radius: 5px;"> {{reuters}}</span></span>
  </h2>

  <div id="recent-trades">
    <table class="table">
      <thead>
        <tr style="padding-inline-end: 10px;">
          <th>#</th>
          <th style="min-width: 85px; max-width: 85px;">{{"price"|translate}}</th>
          <th style="min-width: 85px; max-width: 85px;">{{"qty"|translate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="!companyTrades">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody *ngIf="companyTrades!=null && companyTrades.TradesPerPrice == null">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> No Trades </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center" *ngIf="isTradesLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="companyTrades != null">
        <tr *ngFor="let item of companyTrades.TradesPerPrice" style="width: 100%;">
          <td>{{item.Split}}</td>
          <td style="min-width: 85px; max-width: 85px;">{{item.Price}}</td>
          <td style="min-width: 85px; max-width: 85px;">{{item.Qty | number: "1.0":"en-US"}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
